export const getTrackingErrorCode = (error: unknown, fallback = 'unknown_error') => {
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>;
    const code = String(
      record.code ?? record.errorCode ?? record.status ?? record.name ?? '',
    ).trim();
    if (code) return code;
  }

  if (typeof error === 'string' && error.trim()) return error.trim();

  return fallback;
};

export const getTrackingErrorMessage = (error: unknown, fallback = 'unknown_error') => {
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>;
    const message = String(record.message ?? record.errorMessage ?? record.msg ?? '').trim();
    if (message) return message;
  }

  if (typeof error === 'string' && error.trim()) return error.trim();

  return fallback;
};

export const getFileSizeBucket = (size?: number | null) => {
  const bytes = Number(size || 0);
  if (bytes <= 0) return '0';
  if (bytes <= 100 * 1024) return '0-100kb';
  if (bytes <= 500 * 1024) return '100-500kb';
  if (bytes <= 1024 * 1024) return '500kb-1mb';
  if (bytes <= 5 * 1024 * 1024) return '1-5mb';
  if (bytes <= 10 * 1024 * 1024) return '5-10mb';
  return '10mb+';
};
